import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { SortListService } from 'src/app/service/sort-list.service';

@Component({
  selector: 'app-mandir-employees',
  templateUrl: './mandir-employees.component.html',
  styleUrls: ['./mandir-employees.component.css']
})
export class MandirEmployeesComponent implements OnInit {

   classname = "footer-area footer-area-v1 footer-area-v3  bg_cover";
  ftlogo = "assets/images/logo-2.png";
  ftbg = "assets/images/footer-1.jpg";
  allEmployees = [];
  page: number = 1;
  perpage = 20;
  totalItems = 0;

constructor(
    private apiService : ApiService,
    private sortListService: SortListService,

  ) {
   
  }
  
  ngOnInit(): void {
    this.getAllEmployees();
  }

   getAllEmployees() {
    this.apiService.getPublicDataFromServer(`/employees?page=${this.page}&perpage=${this.perpage}`).subscribe(
      (res:any) => {
          this.allEmployees = res.data;
        this.totalItems = res.total;

      },
      (      err: any) => {
        console.log(err);
      }
    );
  }

  onPageChange(newPage: number) {
    this.page = newPage;
    this.getAllEmployees();
  }

}
